import React, { Component } from 'react';
import { Elements } from 'react-stripe-elements';
import PaymentForm from './PaymentForm.jsx';
import { StripeProvider } from 'react-stripe-elements';

const PaymentFormContainer = (props) => {
    return (
        <div className="Checkout">
            <StripeProvider apiKey={props.tournamentStripeKey}>
                <Elements>
                    <PaymentForm {...props} />
                </Elements>
            </StripeProvider>
        </div>
    );
}

export default PaymentFormContainer;


// WEBPACK FOOTER //
// ./src/features/registration/checkout/EmbededForm/PaymentFormContainer.jsx